<template>
    <div class="slider-default _design section">
        <div class="container">
            <div class="slider-default__static section-margin">
                <h2 class="title slider-default__static-title">
                    Делаем дизайн-проект &laquo;под ключ&raquo;
                </h2>
                <p class="slider-default__static-text">
                    Запросите создание проекта для вашего кафе, ресторана или
                    магазина. Наши дизайнеры создадут выразительный проект под
                    ваши задачи.
                </p>
            </div>
            <div class="section-promo">
                <VueSlickCarousel
                    class="slider-default__promo-slider slider"
                    v-if="sliderItems.length > 0"
                    ref="promo"
                    v-bind="slickOptionsText"
                    @beforeChange="syncSliders"
                >
                    <div
                        class="slider-default__item"
                        v-for="(sliderItem, i) of sliderItems"
                        :key="i"
                    >
                        <p class="section-promo__title sub-title">
                            {{ sliderItem.name }}
                        </p>
                        <div class="section-promo__promo-inner">
                            <img
                                class="section-promo__design-img lazy"
                                src="/assets/img/index/designer-2.jpg"
                                alt="Фото дизайнера"
                            />
                            <p class="section-promo__message">
                                {{ sliderItem.message }}
                                <button
                                    class="link _underline"
                                    type="button"
                                    @click="openForm"
                                >
                                    <span>Обсудить свой проект</span>
                                    <svg viewBox="0 0 13 20">
                                        <polyline
                                            points="0.5 19.5 3 19.5 12.5 10 3 0.5"
                                        />
                                    </svg>
                                </button>
                            </p>
                        </div>
                    </div>
                </VueSlickCarousel>
            </div>
            <VueSlickCarousel
                class="slider-default__img-slider slider"
                v-if="sliderItems.length > 0"
                ref="img"
                v-bind="slickOptionsImg"
                @beforeChange="syncSliders"
            >
                <div
                    class="slider-default__img-slider-wrapper"
                    v-for="(sliderItem, i) of sliderItems"
                    :key="i"
                >
                    <img
                        class="slider-default__img-slider-img"
                        :src="sliderItem.imgSrc"
                        :alt="sliderItem.name + ' фото'"
                    />
                </div>
                <template #prevArrow="arrowOption">
                    <button type="button" class="slick-arrow _prev">
                        <svg class="icon-arrow">
                            <use xlink:href="#arrow-slider" />
                        </svg>
                    </button>
                </template>
                <template #nextArrow="arrowOption">
                    <button type="button" class="slick-arrow _next">
                        <svg class="icon-arrow">
                            <use xlink:href="#arrow-slider" />
                        </svg>
                    </button>
                </template>
            </VueSlickCarousel>
        </div>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';

export default {
    name: 'designSlider',
    components: { VueSlickCarousel },
    created() {
        this.$http.get('/api/slider/portfolio').then((res) => {
            this.sliderItems = res.data;
        });
    },
    data() {
        return {
            sliderItems: [],
            slickOptionsText: {
                arrows: false,
                fade: true,
                infinite: true,
                asNavFor: this.$refs.img,
                centerMode: true,
            },
            slickOptionsImg: {
                arrows: false,
                dots: true,
                fade: true,
                adaptiveHeight: true,
                infinite: true,
                lazyLoad: 'ondemand',
                asNavFor: this.$refs.promo,
            },
        };
    },
    methods: {
        syncSliders(currentPosition, nextPosition) {
            this.$refs.img.goTo(nextPosition);
            this.$refs.promo.goTo(nextPosition);
        },
        openForm() {
            this.$store.commit('setOverlayStatus', true);
            this.$store.commit('setModalStatus', true);
            this.$store.commit('setDesignFormStatus', true);
            document.body.classList.add('_no-scroll');
        },
    },
};
</script>
